import React from 'react';
import QRCode from 'qrcode.react';
import {Helmet,HelmetProvider} from 'react-helmet-async';
import {Step} from '../components/Common';
import {TextButton} from '../components/Input';
import u from '../utilities/Utilities';
import "../styles/staff-vcard.scss";

export default class StaffVCard extends React.Component{

    dormCode=this.props.match.params.dormCode;

    vcardLink=this.props.match.params.vcardLink;

    state={
        content:{},
        ios:false,
    }

    componentDidMount=()=>{
        if(this.dormCode && this.vcardLink){
            this.getStaffInfo()
        }
        else{
            window.location="/404";
        }
    }

    getStaffInfo=()=>{
        u.post({
            url:"/noauth/get-staff-vcard",
            data:{
              dormCode:this.dormCode,
              vcardLink:this.vcardLink
            },
            success:(content)=>{
                console.log(content.vCard);
                this.setState({
                  content:content,
                  ios:u.isiOS()
                });
            },
            error:(error)=>{
                window.location="/404";
            }
        })
    }

    constructVCard=(content)=>{
        const CRLF="\r\n";
        const start="BEGIN:VCARD"+CRLF+"VERSION:4.0"+CRLF
        const end="END:VCARD"+CRLF;

        let vcard = start;
        for(var key in content){
            if(key!="PHOTO")
                vcard = vcard + key + ":" + content[key] + CRLF;
        }
        vcard=vcard+end;
        console.log(vcard);
        return vcard;
    }

    render=()=>{
        const {content,ios} = this.state;

        return (
            <HelmetProvider>
                <Helmet>
                    <title>{(content.staffName) ? content.staffName : "Smartdorm"} | VCard</title>
                    <meta name="viewport" content="width=device-width,initial-scale=1"/>
                    <meta name="viewport" content="height=device-height,initial-scale=1"/>
                </Helmet>
                <div className='vcard-page-container'>
                    <div className='vcard-container'>
                        {
                            (content.vCardTemplate == "s11")
                                ?
                                <S11 content={content}
                                     ios={ios}/>
                                :
                                null
                        }
                    </div>
                </div>
                <div className={"vcard-footer"+ ((ios)?" ios":"")}/>
            </HelmetProvider>
        )
    }
}

class S11 extends React.Component{
    state={
        step:"view",
        mode:"light",
    }

    componentDidMount=()=>{
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            // dark mode
            this.setState({mode:"dark"})
        }

        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
            this.setState({mode:(event.matches ? "dark" : "light")})
        });
    }

    onQR=()=>{
        this.setState({step:(this.state.step=="view") ? "qr" : "view"});
    }

    onDownload=()=>{
        const content=this.props.content;
        const FileSaver = require('file-saver');
        const blob = new Blob([content.vCard], {type: "text/vcard;charset=utf-8"});
        FileSaver.saveAs(blob, content.staffName+".vcf");
    }

    render=()=>{
        const {content,ios} = this.props;

        return(
            <div className={"s11-vcard" + ((ios) ? " ios" : "")}>
                <div className="company-logo-container">
                    <img src="/images/vcard/s11/logo.png" className="company-logo"/>
                </div>

                <div className="s11-detail-container">
                    <div className='s11-details-fix'>
                      <div className='s11-detail-item photo'><img src={content.avatarLink} onClick={this.onQR}/></div>

                      <div className="s11-details-flex">
                          <div className="s11-detail-item name chinese" style={{marginBottom:"0"}}>{content.vcardChineseName}</div>
                          <div className="s11-detail-item name" style={{marginTop:"0"}}>{content.staffName}</div>
                          {
                              (content.vcardEducation)
                                  ?
                                  <div className="s11-detail-item">
                                    <img src="/images/vcard/s11/education.png" className="detail-icon"
                                         style={{width:"16px",marginLeft:"-3px",marginRight:"9px",marginBottom:"0"}}/>
                                    <div className="s11-detail-content">{content.vcardEducation}</div>
                                  </div>
                                  :
                                  null
                          }
                          <div className="s11-detail-item">
                            <img src="/images/vcard/s11/user.png" className="detail-icon"/>
                            <div className="s11-detail-content">{content.designation}</div>
                          </div>
                          <div className="s11-detail-item">
                            <img src="/images/vcard/s11/phone.png" className="detail-icon"/>
                            <div className="s11-detail-content">{content.contactNumber}</div>
                          </div>
                          <div className="s11-detail-item">
                            <img src="/images/vcard/s11/email.png" className="detail-icon"/>
                            <div className="s11-detail-content">{content.email}</div>
                          </div>
                      </div>
                    </div>

                    <div className="s11-details-float">
                        <div className="add-contact">
                            <TextButton onClick={this.onDownload}>Add to Contact</TextButton>
                        </div>
                        <div><span className="s11-bold-text">www.s11capital.com</span> | Tel: 6587 6200 | Fax: 6509 9453</div>
                        <div style={{marginTop:"3px"}}>2 Seletar North Link, PPT Lodge 1B, #02-01, Singapore 797601</div>
                    </div>
                </div>

                <div className="s11-divider"/>

                <div className="s11-bottom-container">
                    <div className="s11-bottom-bg-container">
                        <img src="/images/vcard/s11/logo.png" className="s11-bottom-bg"/>
                    </div>
                    <div className="s11-swap-flex">
                        <Step active={this.state.step=="view"} style={{height:"100%"}}>
                            <div className="s11-swap-flex-step">
                                <div className="s11-services">
                                    <div className="s11-bold">Our Services:</div>
                                    <div>
                                        <div className="s11-bottom-item">Project Analysis, Management & Consultancy</div>
                                        <div className="s11-bottom-item">Turnkey Dormitory Solutions</div>
                                        <div className="s11-bottom-item">Design & Build</div>
                                        <div className="s11-bottom-item">Outsourced Dormitory Operations</div>
                                    </div>
                                </div>
                                <div className="s11-services">
                                      <div className="s11-bold">Our Sites:</div>
                                      <div>
                                          <div className="s11-bottom-item">PPT Lodge 1B @ Seletar North Link</div>
                                          <div className="s11-bottom-item">Changi Lodge 2 @ Tanah Merah Coast Rd</div>
                                          <div className="s11-bottom-item">HSJV Dormitory @ CAG T5 Site</div>
                                      </div>
                                </div>
                                <div className="supporting-logo-container">
                                    <img src="/images/vcard/s11/l-1.jpg" id="bl-1" className="supporting-logo"/>
                                    <img src="/images/vcard/s11/l-2.jpg" id="bl-2" className="supporting-logo"/>
                                    <img src="/images/vcard/s11/l-3.png" id="bl-3" className="supporting-logo"/>
                                </div>
                            </div>
                        </Step>

                        <Step active={this.state.step=="qr"} style={{height:"90%"}}>
                            <div className="s11-swap-flex-step" style={{justifyContent:"center"}}>
                                <div className="s11-vcard-instruction">
                                    POINT YOUR CAMERA TO ADD CONTACT
                                </div>
                                <div className="vcard-qr-container">
                                {
                                    (content.vCard)
                                        ?
                                        <div className="vcard-qr">
                                            <QRCode value={content.vCard}
                                                    level="M"
                                                    fgColor="#000"
                                                    size={200}
                                                    imageSettings={{
                                                        src:"/images/vcard/qr-image.png",
                                                        width:50,
                                                        height:50,
                                                        excavate:true,
                                                    }}
                                                    />
                                        </div>
                                        :
                                        null
                                }
                                </div>
                            </div>
                        </Step>
                    </div>
                </div>
            </div>
        )
    }
}
